import { formatNumber } from '@/utils/format'

interface Payload {
  value?: number | string
  name?: string
  color?: string
  payload?: Record<string, unknown>
}

/** Shared Recharts tooltip: surface card, text in ink tokens, a colour swatch carries identity. */
export function ChartTooltip({
  active,
  payload,
  label,
  format,
}: {
  active?: boolean
  payload?: Payload[]
  label?: string | number
  /** Renders a value with its unit (already translated); defaults to a plain formatted number. */
  format?: (value: number) => string
}) {
  if (!active || !payload?.length) return null
  return (
    <div className="rounded-control border border-line bg-surface px-3 py-2 shadow-raised">
      {label !== undefined ? <p className="text-xs font-medium text-muted">{label}</p> : null}
      {payload.map((p, i) => (
        <p key={i} className="mt-0.5 flex items-center gap-2 text-sm font-semibold text-ink tabular">
          <span className="size-2 rounded-full" style={{ backgroundColor: p.color }} aria-hidden="true" />
          {typeof p.value === 'string' && Number.isNaN(Number(p.value))
            ? p.value
            : (format ?? formatNumber)(Number(p.value))}
        </p>
      ))}
    </div>
  )
}
